import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SessionBookingVM } from '../../../models/SessionBookingVM';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { UserType } from '../../../models/UserType';
import { MessagePartyVM } from '../../../models/MessagePartyVM';

@Component({
  selector: 'upcoming-session-card',
  templateUrl: './upcoming-session-card.component.html',
  styleUrls: ['./upcoming-session-card.component.scss']
})
export class UpcomingSessionCardComponent extends BaseComponent implements OnInit {

  @Output() OnSessionDataChanged: EventEmitter<void> = new EventEmitter();
  @Input() model: SessionBookingVM = new SessionBookingVM();
  cancelStage: number = 0;
  //0 - default
  //1 - cancel applicable
  //2 - cancel non applicable
  //3 - cancel complete

  constructor(private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService) {
    super(route);
  }

  ngOnInit(): void {

  }

  cancel() {
    this.emitDisplayLoadingDialog(true);

    switch (this.cancelStage) {
      case 0:
        //check if session can be cancelled
        this.accService.canCancelSession(this.model)
          .subscribe(
            r => {
              this.cancelStage = r ? 1 : 2;
            },
            e => e,
            () => {
              this.emitDisplayLoadingDialog(false);
            }
          );
        break;
      case 1:
        //cancel session
        this.accService.cancelSession(this.model)
          .subscribe(
            r => {
              if (r) {
                this.cancelStage = 3;
              }
              else {

              }
            },
            e => e,
            () => {
              this.emitDisplayLoadingDialog(false);
            }
          );
        break;
      case 2:
        this.exitCancel();
        break;
      case 3:
        this.OnSessionDataChanged.emit();
        break;
    }


    return false;
  }

  exitCancel() {
    this.cancelStage = 0;
    this.emitDisplayLoadingDialog(false);
  }

  reply() {
    var otherParty = new MessagePartyVM();
    otherParty.name = this.model.counsellorName;
    otherParty.userId = this.model.counsellorUserId;
    otherParty.userType = UserType.counsellor;
    otherParty.profileImage = this.model.professionalProfileImage;

    this.accService.messageOtherParty = otherParty;

    this.router.navigateByUrl('/messagewrite');
  }
}
